import { PropositionAllocation, PropositionFeeFrequency } from "@hubcapp/types";
import { formatCurrency } from "@ds-developer/frontend";

const propositionFeeFrequencyMap: Record<PropositionFeeFrequency, string> = {
  [PropositionFeeFrequency.Weekly]: "week",
};

export const propositionToFranchiseDetail = (
  allocation: PropositionAllocation,
) => ({
  id: allocation.id,
  package: allocation.proposition.name,
  startDate: new Date(allocation.fromDate),
  endDate: allocation.toDate ? new Date(allocation.toDate) : undefined,
  fee: `${formatCurrency(allocation.proposition.price.includingVAT, false)}/${
    propositionFeeFrequencyMap[allocation.proposition.price.frequency]
  }`,
});
